import api from './api';

const projectService = {
  /**
   * Get all projects for the current user
   */
  async getUserProjects(userId, options = {}) {
    const { page, limit, status, realmId, search } = options;
    const params = new URLSearchParams();

    if (page) params.append('page', page);
    if (limit) params.append('limit', limit);
    if (status !== undefined) params.append('status', status);
    if (realmId) params.append('realmId', realmId);
    if (search) params.append('search', search);

    const response = await api.get(`/api/projects/user/${userId}?${params.toString()}`);
    return response;
  },

  /**
   * Get all projects (admin/editor)
   */
  async getAllProjects(options = {}) {
    const { page, limit, status, realmId, search } = options;
    const params = new URLSearchParams();

    if (page) params.append('page', page);
    if (limit) params.append('limit', limit);
    if (status !== undefined) params.append('status', status);
    if (realmId) params.append('realmId', realmId);
    if (search) params.append('search', search);

    const response = await api.get(`/api/projects?${params.toString()}`);
    return response;
  },

  /**
   * Get all projects for a realm
   */
  async getRealmProjects(realmId, options = {}) {
    const { page, limit, status, search } = options;
    const params = new URLSearchParams();

    if (page) params.append('page', page);
    if (limit) params.append('limit', limit);
    if (status !== undefined) params.append('status', status);
    if (search) params.append('search', search);

    const response = await api.get(`/api/projects/realm/${realmId}?${params.toString()}`);
    return response;
  },

  /**
   * Get project by ID
   */
  async getProject(id) {
    const response = await api.get(`/api/projects/${id}`);
    return response;
  },

  /**
   * Get project with jobs
   */
  async getProjectWithJobs(id) {
    const response = await api.get(`/api/projects/${id}/with-jobs`);
    return response;
  },

  /**
   * Get project statistics
   */
  async getProjectStatistics(id) {
    const response = await api.get(`/api/projects/${id}/statistics`);
    return response;
  },

  /**
   * Create a new project
   */
  async createProject(projectData) {
    const response = await api.post('/api/projects', projectData);
    return response;
  },

  /**
   * Update a project
   */
  async updateProject(id, projectData) {
    const response = await api.put(`/api/projects/${id}`, projectData);
    return response;
  },

  /**
   * Update project status
   */
  async updateProjectStatus(id, status) {
    const response = await api.post(`/api/projects/${id}/status`, { status });
    return response;
  },

  /**
   * Update project current step
   */
  async updateCurrentStep(id, step) {
    const response = await api.post(`/api/projects/${id}/step`, { step });
    return response;
  },

  /**
   * Delete a project
   */
  async deleteProject(id) {
    const response = await api.delete(`/api/projects/${id}`);
    return response;
  }
};

export default projectService;

